import script from "./DeviceExtractionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceExtractionsView.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceExtractionsView.vue?vue&type=style&index=0&id=54be7cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54be7cc4"]])

export default __exports__